import { FC } from 'react';

import AttributeItem, { AttributeGrid } from 'dashboard/components/AttributeItem';
import Permissioned from 'dashboard/components/Permissioned';
import { formatAddress } from 'dashboard/lib/utils/formatters';
import { ReportEquifaxOneview } from 'dashboard/models/report/integration/equifax-oneview';
import { Permission } from 'lib/permissions';

interface EquifaxOneviewProps {
  report: ReportEquifaxOneview;
  isRedacted: boolean;
}

const EquifaxOneview: FC<EquifaxOneviewProps> = ({
  report: {
    attributes: {
      query: {
        'name-first': nameFirst,
        'name-middle': nameMiddle,
        'name-last': nameLast,
        'name-suffix': nameSuffix,
        'address-street-1': addressStreet1,
        'address-city': addressCity,
        'address-state': addressState,
        'address-zip': addressZip,
        birthdate: birthdate,
        'reference-id': referenceId,
        'social-security-number': socialSecurityNumber,
      },
    },
  },
  isRedacted,
}: EquifaxOneviewProps) => {
  const truncatedSSN = socialSecurityNumber?.substring(socialSecurityNumber?.length - 4);
  return (
    <AttributeGrid colCount={4}>
      <AttributeItem
        title='First Name'
        value={nameFirst}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-equifax-oneview__name-first'
      />
      <AttributeItem
        title='Middle Name'
        value={nameMiddle}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-equifax-oneview__name-middle'
      />
      <AttributeItem
        title='Last Name'
        value={nameLast}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-equifax-oneview__name-last'
      />
      <AttributeItem
        title='Suffix'
        value={nameSuffix}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-equifax-oneview__name-suffix'
      />
      <AttributeItem
        title='Address'
        value={formatAddress({
          addressStreet1,
          addressCity,
          addressSubdivision: addressState,
          addressPostalCode: addressZip,
          countryCode: 'US',
        })}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-equifax-oneview__address'
      />
      <AttributeItem
        title='Birthdate'
        value={birthdate}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-equifax-oneview__birthdate'
      />
      <Permissioned
        permission={Permission.ReportSsnView}
        fallback={
          <AttributeItem
            title='SSN'
            value={truncatedSSN}
            placeholder='SSN'
            isRedacted={isRedacted}
            dataTest='report-equifax_oneview__ssn'
          />
        }
      >
        <AttributeItem
          title='SSN'
          value={socialSecurityNumber}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-equifax_oneview__ssn'
        />
      </Permissioned>
      <AttributeItem
        title='Customer Reference ID'
        value={referenceId}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-equifax-oneview__reference-id'
      />
    </AttributeGrid>
  );
};

export default EquifaxOneview;
